import React, { ChangeEvent, useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Tooltip
} from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../components/TextAreaComponents/TextAreaComponents.tsx";
import galleryIcon from "./../../../assets/icons/gallery.png";
import plusIcon from "./../../../assets/icons/plus.png";
import "./AddItem.css";
import { Delete } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import StickyHeadTable from "../../components/SpecificationTable/Specification.tsx";
import Details from "./../../product/components/Details.tsx";
import Story from "./../../product/components/Story.tsx";
import Instructions from "./../../product/components/Instructions.tsx";
import Cancel from "./../../../assets/icons/close.png";
import DetailsTable from "../../components/SpecificationTable/DetailsTable.tsx";
import SectionTable from "./SectionTable.tsx";
import ChickenIcon from "./../../../assets/icons/turkey.png";
import ChickenLegIcon from "./../../../assets/icons/chicken-leg.png";
import Burger1Icon from "./../../../assets/icons/burger1.png";
import Burger2Icon from "./../../../assets/icons/burger.png";
import FullPizzaIcon from "./../../../assets/icons/pizza.png";
import pizzaIcon from "./../../../assets/icons/pizza (1).png";
import { getMinimalContentHeight } from "@mui/x-data-grid/hooks/features/rows/gridRowsUtils.js";
import SectionTableSubSection from "./SectionTableSubSection.tsx";
import CustomDialog from "../../components/CustomDialog/CustomDialog.tsx";
import AddRestaurantDialog from "../../restaurantsetup/components/AddRestaurantDialog/AddRestaurantDialog.tsx";
import itemImg from "./../../../assets/icons/menu.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal.js";
import ArchiveDialog from "./AddMenu/ArchiveDialog.tsx";
import CustomArchiveDialog from "./AddMenu/CustomArchiveDialog.tsx";
import { uploadOneFiles } from "../../../fileUploader/SingleFileUploader.js";
import { cleanDigitSectionValue } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";
import SchedulerComponent from "../components/SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx";
import MenuSchedulerSelectDialog from "../components/AddMenu/MenuSchedulerSelectDialog.tsx";
import LoadingView from "../../components/LoadingView/LoadingView.js";

// const imageMap = [
//     { code: 1, icon: ChickenIcon, label: 'Chicken' },
//     { code: 2, icon: ChickenLegIcon, label: 'Chicken' },
//     { code: 3, icon: Burger1Icon, label: 'Chicken' },
//     { code: 4, icon: Burger2Icon, label: 'Chicken' },
//     { code: 5, icon: FullPizzaIcon, label: 'Chicken' },
//     { code: 6, icon: pizzaIcon, label: 'Chicken' },
// ]

const imageSectionMap = [
  { codeSection: 1, icon: ChickenIcon, label: "Chicken" },
  { codeSection: 2, icon: ChickenLegIcon, label: "Chicken" },
  { codeSection: 3, icon: Burger1Icon, label: "Chicken" },
  { codeSection: 4, icon: Burger2Icon, label: "Chicken" },
  { codeSection: 5, icon: FullPizzaIcon, label: "Chicken" },
  { codeSection: 6, icon: pizzaIcon, label: "Chicken" },
];

function AddMenuDialog(props) {
  //test start
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [selectedSectionValue, setSelectedSectionValue] = useState<any>(null);
  const [selectedData, setSelectedData] = useState({});
  const [keyword, setKeyword] = useState(null);
  const [imageMap, setimageMap] = useState([]);
  const [typrOfMenuDatas, setTyprOfMenuDatas] = useState([]);
  const [restaurantId, setRestaurantId] = useState([]);
  const apiAddress = process.env.REACT_APP_SECRET;
  const [loadingModal, SetloadingModal] = React.useState(false);
  // const token = jwt_decode(localStorage.getItem('gotasteadmintoken'));
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const [selectedValueValid, setselectedValuealid] = useState(false);

  const [scheduleSelections, setScheduleSelections] = useState({});

  

  console.log(scheduleSelections)

  const handleAutocompleteChange = (event: ChangeEvent<{}>, value: any) => {
    setSelectedValue(value);
    setselectedValuealid(false);
  };
  console.log(selectedValue);
  const handleAutocompleteSectionChange = (
    event: ChangeEvent<{}>,
    value: any
  ) => {
    setSelectedSectionValue(value);
  };
  const handleKeyword = (event) => {
    setKeyword(event.target.value);
  };
  const [sectionDatas, setSectionDatas] = useState([]);
  const loadRestaurant = () => {
    axios
      .get(apiAddress + "/api/RestaurantUserMapper/getbyuserid/" + token.UserId)
      .then((response) => {
        console.log(response.data);

        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setSectionDatas(list);
      });
  };

  useEffect(() => {
    loadRestaurant();
    loadRestaurantName();
    console.log("Hit");
    axios.get(apiAddress + "/api/Icon/getallicon").then((response) => {
      console.log(response.data);
      var list = [];
      response.data.map((dt, i) => {
        var obj = { code: dt.id, icon: dt.url, label: dt.name };
        list.push(obj);
      });
      setimageMap(list);
    });
  }, []);

  useEffect(() => {
    axios
      .get(apiAddress + "/api/Menu/GetAllMenuTypeListAsync")
      .then((response) => {
        console.log(response.data);
        var list = [];
        console.log(list);
        response.data.map((dt, i) => {
          var obj = { id: dt.id, title: dt.typeName };
          list.push(obj);
        });
        setTyprOfMenuDatas(list);
      });
  }, []);

  const menuDatas = [];

  const fileUpload = async (data) => {
    console.log(data);
    var res = await uploadOneFiles(data[0]);
    return res;
  };
  const onClickSave = async () => {
    var logoUrl = await fileUpload(logoImg);
    var valid = true;
    var selectedRestaurantCount = 0;
    if (!!keyword == false) {
      valid = false;
    }

    restaurantAdded.forEach((dt, i) => {
      // var kitchen = menuIds.find((x) => x.restaurantId == dt.id);
      // var DeliveryCheck = checkedState.find((x) => x.resId == dt.id);
      // var CollectionOnlyCheck = CollectionOnlycheckedState.find((x) => x.resId == dt.id);
      // console.log(DeliveryCheck)
      selectedRestaurantCount++;

      // var matchMenu = menuType[dt.id];
      // console.log(menuType)
      // console.log(matchMenu)
      // var matchschedule = scheduleSelections[dt.id];
      // if (!matchschedule) {
      //   toast.error(`Please select a schedule for ${dt.title}`, {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: true,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     theme: "colored",
      //   });
      //   return; // Skip further processing for this restaurant
      // }

     
        let obj = {
          Id: "123",
          MenuName: "",
          MenuTypeId: [],
          IconId: logoUrl[0],
          IsActive: true,
          CreationId: "1",
          KitchenId: 0,
          // RestaurantIds: [],
          RestaurantId: "",
        };
        const Data = {
          Icon: logoUrl[0],
          Keyword: keyword,
          Section: selectedSectionValue,
        };
        setSelectedData(Data);

        obj.Id = "123";
        obj.MenuName = keyword;

        // let menTypeIds = [];
        // matchMenu.map((dt, i) => {

        //   menTypeIds.push(dt.id);
        // });

        // obj.MenuTypeId = menTypeIds;

        if (selectedValue) {
          obj.IconId = logoUrl[0];
        }

        obj.IsActive = switchCheck;

        // restaurantAdded.map((dt, i) => {
        //   restaurantId.push(dt.id);
        // });
        obj.RestaurantId = dt.id;
        obj.isDeleted = false;
        obj.isArchived = false;
        //obj.KitchenId = kitchen.id;
        obj.isDelivery = false;
        obj.isCollectionOnly = false;
        obj.scheduleId = null;
        menuDatas.push(obj);
    });


    //validation start
    var valid = true;
    if (keyword == undefined) {
      valid = false;
      toast.error("Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else if (logoUrl[0] == null) {
      valid = false;
      toast.error("Icon is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    // } else if (menuType == undefined) {
    //   valid = false;
    //   toast.error("Menu type is required", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    } else if (selectedRestaurantCount != menuDatas.length) {
      valid = false;
      toast.error("kitchen is required for all Selected Restaurants", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    // else if (restaurantId.length == 0) {
    //     valid = false
    //     toast.error("Restaurant is required", {
    //         position: "top-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "colored",
    //     });
    // }
    //validation end

    var url = apiAddress + "/api/Menu";
    // const restaurant = localStorage.getItem('restaurant');
    // var res = JSON.parse(restaurant);
    // console.log(res);
    // obj.RestaurantId.push(res.id);

    // const menuData = [obj];
    console.log(menuDatas);
    if (valid) {
      SetloadingModal(true);
      axios.post(url, menuDatas).then((response) => {
        console.log(response.data);
        SetloadingModal(false);
        toast.success("successfully submitted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        props.onHandleSelectedData(selectedData);
        props.onHandleAddItem(false);
        props.loaddataonfly();
      });
    }

    setopenConfirmaitonModal(false);
  };

  const onClickUpdate = async () => {
    SetloadingModal(true);
    console.log(logoImg);
    var logoImageUrl = "";
    if (typeof logoImg[0] == "string") {
      logoImageUrl = logoImg[0];
    } else {
      console.log("called");
      var res = await fileUpload(logoImg);
      logoImageUrl = res[0];
    }
    var valid = true;
    if (!!keyword == false) {
      valid = false;
    }
    var obj = {
      id: props.editKeywordData.id,
      KeywordTagName: keyword,
      KeywordTagImage: logoImageUrl,
      isActive: true,
      creatorId: "string",
      creationDate: "2023-08-21T06:38:08.240Z",
      modifierId: "string",
      modificationDate: "2023-08-21T06:38:08.240Z",
    };
    console.log(obj);
    var url = apiAddress + "/api/Keyword/UpdateKeywordTag";

    if (valid) {
      axios.put(url, obj).then((response) => {
        SetloadingModal(false);
        toast.success("successfully submitted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        console.log(response.data);
        props.onHandleKeywordDialog(false);
      });
    }
  };

  //test end

  //dialog start
  const [openIconDilaog, setOpenIconDialog] = useState(false);
  const [openArchiveDilaog, setopenArchiveDilaog] = useState(false);
  const [openRestaurantDialog, setRestaurantDialog] = useState(false);

  const handleDialogOpen = (name) => {
    if (name == "icon") {
      setOpenIconDialog(true);
    } else if (name == "restaurant") {
      setRestaurantDialog(true);
    }
  };

  const handleDialog = () => {
    setOpenIconDialog(false);
  };
  const handleAddItem = () => {
    setRestaurantDialog(false);
    setopenArchiveDilaog(false);
  };

  //dialog end

  const [state, setState] = useState<ImageUploadState>({
    selectedImages: props.editKeywordData?.imgurl || [],
  });

  console.log(state);

  console.log(state);

  const [logoImg, setlogoImg] = useState([]);

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages];
    updatedImages.splice(index, 1);
    setState({ selectedImages: updatedImages });
  };

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      setlogoImg(filesToUpload);
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleClose = () => {
    // props.onHandleAddItem(false);
    // setKeyword(null);
    // setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(true);
  };

  const handleAddDialogClose = () => {
    props.onHandleAddItem(false);
    //setKeyword(null)
    setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(false);
  };
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [menuType, setMenuType] = useState({});

  const handleMenuChange = (restaurantId, newValue) => {
    setMenuType((prev) => ({
      ...prev,
      [restaurantId]: newValue,
    }));

    // Check if "Delivery" is the only selected menu type
    const isOnlyDeliverySelected =
      newValue.length === 1 && newValue.some((menu) => menu.title === "Delivery");

    const isDeliverySelected = newValue.some((menu) => menu.title === "Delivery");
    setCheckedState((prevState) =>
      prevState.map((state) =>
        state.resId === restaurantId
          ? {
            ...state,
            checked: isOnlyDeliverySelected ? true : isDeliverySelected ? state.checked : false, // Auto-enable if only "Delivery" is selected
            disabled: isOnlyDeliverySelected, // Disable toggle if only "Delivery" is selected
          }
          : state
      )
    );
  };


  console.log(autoCompleteValue);
  console.log(menuType);
  const renderOption = (option) => (
    <Grid container alignItems="center">
      <Grid item>
        <img src={option.icon} alt="Icon" style={{ width: "1rem" }} />
      </Grid>
      <Grid item>
        <Typography>{option.title}</Typography>
      </Grid>
    </Grid>
  );

  // const getFoodSectionImage = (codeSection) => {
  //     const foundSectionItem = imageSectionMap.find((item) => item.codeSection === codeSection)
  //     if (foundSectionItem) {
  //         return foundSectionItem.icon
  //     }
  //     return null
  // }
  // const getFoodImage = (code) => {

  //     const foundItem = imageMap.find((item) => item.code === code)
  //     if (foundItem) {
  //         return foundItem.icon
  //     }
  //     return null
  // }

  const { open, onClose, dialogType } = props;
  const [restaurantDatas, setRestaurantDatas] = React.useState([]);
  const [userId, setUserId] = useState();
  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const RestaurantLocaltoken = JSON.parse(localStorage.getItem("restaurant"));
  const token = localStorage.getItem("gotasteadmintoken");

  const [openLeosModal, setopenLeosModal] = useState(false);

  console.log(RestaurantLocaltoken);
  const [restaurantAdded, setRestaurantAdded] = useState([
  ]);
  const [isRestaurantSelected, setIsRestaurantSelected] = useState(false);

  useEffect(() => {
    var PreFetchedRestaurant = restaurantDatas.find((x) => x.id == RestaurantLocaltoken.id);
    if (PreFetchedRestaurant) {
      let resList = []
      resList.push(PreFetchedRestaurant)
      setRestaurantAdded(resList)
      setIsRestaurantSelected(resList)
    }
  }, [restaurantDatas]);

  // Handler for restaurant selection

  //{ id: RestaurantLocaltoken.id, title: RestaurantLocaltoken.name },
  const [tempRestaurantAdded, setTempRestaurantAdded] = useState();
  console.log(restaurantAdded);
  const restaurantAddedvalue = (props) => {
    console.log(props);
    // if (props.length > restaurantAdded.length) {
    //   setRestaurantAdded(props);
    //   console.log(restaurantAdded);
    // } else {
    //   setopenLeosModal(true);
    //   setTempRestaurantAdded(props);
    // }
    setRestaurantAdded(props);
    setIsRestaurantSelected(props && props.length > 0)
  };

  const handleLeosClose = () => {
    console.log(tempRestaurantAdded);
    setRestaurantAdded(tempRestaurantAdded);
    setopenLeosModal(false);
  };

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) { }
    }

    axios
      // .get(apiAddress + "/api/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=" + decodedData.UserId+"&restaurantId="+Restauranttoken.id)
      .get(
        apiAddress +
        `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
            isDelivery: dt.isDelivery,
            isDeliveryOnly: dt.isDeliveryOnly,
            isCollectionOnly: dt.isCollectionOnly
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
      });
  };

  const [switchCheck, setswitchCheck] = useState(true);
  const handleSwitchChange = () => {
    if (switchCheck == true) {
      //setopenArchiveDilaog(true);
      setswitchCheck(false);
      //setIsactiveDialogType("Is Active");
    } else {
      //setopenArchiveDilaog(true);
      handleSwitchToggle();
      //setswitchCheck(!switchCheck);
      setswitchCheck(true);
    }
  };

  const handleSwitchToggle = () => {
    setswitchCheck(!switchCheck);
  };

  // const sectionDatas = [
  //     { id: '1', title: 'Pot Kettle black London' },
  //     { id: '2', title: 'Pot Kettle black Manchester' },
  //     { id: '3', title: 'Pot Kettle black User' }
  // ]
  // const typrOfMenuDatas = [
  //     { id: 2, title: 'Online' },
  //     { id: 3, title: 'Whole sales' },
  //     { id: 4, title: 'Corporate ' },
  //     { id: 4, title: 'Instore ' },

  const [IsactiveDialogType, setIsactiveDialogType] = useState("");

  const deleteBin = () => {
    console.log("Menu Archive");
  };

  const [menuData, setMenuData] = useState([]);
  const [allMenuData, setAllMenuData] = useState([]);

  useEffect(() => {
    if (restaurantAdded.length > 0) {
      loadMenuData();
    }
  }, [restaurantAdded]);

  const loadMenuData = async () => {
    var list = [];
    var Alllist = [];
    var filteredList = [];
    console.log(restaurantAdded);
    const idList = restaurantAdded.map((d) => d.id);
    axios
      .post(
        apiAddress + "/api/Kitchen/GetAllKitchensByRestaurantIdList",
        idList
      )
      .then((response) => {
        console.log(response);
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.name,
            img: dt.logoUrl,
            restaurantName: dt.restaurantName,
            restaurantId: dt.restaurantId,
          };
          list.push(obj);
          dt.MenuRestaurantMapperLists = [];
          Alllist.push(dt);
          console.log(Alllist);
        });
      });

    console.log(menuIds);

    setAllMenuData(Alllist);
    console.log(list);
    setMenuData(list);
  };

  console.log(allMenuData);

  // useEffect(() => {
  //   loadMenuData();
  // }, []);

  const [menuIds, setMenuIds] = useState([]);

  const addValue = (props) => {
    if (
      menuIds.length > 0 &&
      props.length > 0 &&
      props.length > menuIds.length
    ) {
      const data = menuIds.find(
        (x) => x.restaurantId == props[props.length - 1].restaurantId
      );
      console.log(props);

      if (data) {
        toast.error("Kitchen already Add For the resturant", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        setMenuIds(props);
      }
    } else {
      setMenuIds(props);
    }
  };

  const [Schedule, setSchedule] = React.useState([]);
  const getSchedule = (props) => {
    console.log(props)
    setSchedule(props);
    // Schedule.push(props)
  };
  const [checkedState, setCheckedState] = useState(
    restaurantAdded.map((restaurant) => {
      const isOnlyDeliverySelected =
        menuType[restaurant.id]?.length === 1 &&
        menuType[restaurant.id]?.some((menutype) => menutype.title === "Delivery");

      return {
        resId: restaurant.id,
        checked: isOnlyDeliverySelected ? true : restaurant.isDelivery, // Auto-enable if only "Delivery" is selected
        disabled: isOnlyDeliverySelected, // Disable toggle if only "Delivery" is selected
      };
    })
  );

  const [CollectionOnlycheckedState, setCollectionOnlyCheckedState] = useState(
    restaurantAdded.map((res) => ({
      resId: res.id,
      checked: res.isCollectionOnly ? true : false,
    }))
  );

  const handleCollectionOnlyChange = (resId) => {
    setCollectionOnlyCheckedState((prevState) =>
      prevState.map((state) =>
        state.resId === resId ? { ...state, checked: !state.checked } : state
      )
    );
  };

  useEffect(() => {
    setCollectionOnlyCheckedState(
      restaurantAdded.map((res) => ({
        resId: res.id,
        checked: res.isCollectionOnly ? true : false,
      }))
    );
  }, [restaurantAdded]);
  
  const handleCheckboxChange = (index) => {
    const restaurantId = restaurantAdded[index].id;
    const isOnlyDeliverySelected =
      menuType[restaurantId]?.length === 1 &&
      menuType[restaurantId]?.some((menutype) => menutype.title === "Delivery");

    // Prevent toggling off if only "Delivery" is selected
    if (isOnlyDeliverySelected) {
      return;
    }

    // Toggle the checkbox state
    setCheckedState((prevState) =>
      prevState.map((state, i) =>
        i === index ? { ...state, checked: !state.checked } : state
      )
    );
  };

  // useEffect(() => {
  //   setCheckedState((prevState) => {
  //     const updatedState = restaurantAdded.map((restaurant) => {
  //       const existingState = prevState.find((state) => state.resId === restaurant.id);
  //       return existingState || { resId: restaurant.id, checked: restaurant.isDelivery };
  //     });
  //     return updatedState;
  //   });
  // }, [restaurantAdded]);

  useEffect(() => {
    setCheckedState((prevState) => {
      return restaurantAdded.map((restaurant) => {
        const isDeliveryEnabled =
          menuType[restaurant.id]?.some((menu) => menu.title === "Delivery") || false;

        return {
          resId: restaurant.id,
          checked: isDeliveryEnabled ? prevState.find((state) => state.resId === restaurant.id)?.checked || false : false, // Uncheck if disabled
        };
      });
    });
  }, [restaurantAdded, menuType]);


  useEffect(() => {
    console.log(checkedState)
    console.log(checkedState[0]?.checked)

  }, [checkedState])

  useEffect(() => {
    console.log(restaurantAdded)
  }, [restaurantAdded])

  const menuTypes = ["Wholesale", "Dine-in", "Delivery"];

  const handleCheckboxChange2 = (restaurantId, menuType) => (event) => {
    setSelectedMenuTypes((prev) => {
      const updated = { ...prev };

      // Ensure the restaurantId key exists and is initialized as an array
      if (!updated[restaurantId]) {
        updated[restaurantId] = [];
      }

      if (event.target.checked) {
        // Add the menu type if checked
        updated[restaurantId] = [...updated[restaurantId], menuType];
      } else {
        // Remove the menu type if unchecked
        updated[restaurantId] = updated[restaurantId].filter((type) => type !== menuType);
      }

      return updated;
    });
  };

  const [selectedMenuTypes, setSelectedMenuTypes] = useState(
    restaurantAdded.reduce((acc, restaurant) => {
      acc[restaurant.id] = [];
      return acc;
    }, {})
  );

  const [openMenuSchedulerSelectionDialog, setopenMenuSchedulerSelectionDialog] = useState(false);

  const handleMenuSchedularDialogOpen = () => {
    setopenMenuSchedulerSelectionDialog(true)
  }
  const handleMenuSchedulerDialogClose = () => {
    setopenMenuSchedulerSelectionDialog(false)
  }

  const handleSelectScheduler = () => {
    if (!isRestaurantSelected) {
      toast.error("Please select a restaurant first", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      handleMenuSchedularDialogOpen();
    }
  };

  useEffect(() => {
    console.log(selectedMenuTypes)
  }, [selectedMenuTypes])

  const getMenuOptionsForRestaurant = (restaurant) => {
    if (restaurant.isDelivery && restaurant.isDeliveryOnly) {
      // ✅ Case 1: Only show "Delivery"
      return typrOfMenuDatas.filter((menu) => menu.title === "Delivery");
    } else if (!restaurant.isDelivery) {
      // ✅ Case 2: Only show "In-Store"
      return typrOfMenuDatas.filter((menu) => menu.title === "In-Store");
    } else if (restaurant.isDelivery && !restaurant.isDeliveryOnly) {
      // ✅ Case 3: Show all three types
      return typrOfMenuDatas;
    }
    return []; // Fallback (optional)
  };


  // ]
  const closeLoadingModal = () => {
    SetloadingModal(false);
  };
  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={"lg"}
          className="addSectionDialog"
          open={props.open}
          onClose={handleClose}
        >
          <ToastContainer></ToastContainer>
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to save this?"}
            open={openConfirmaitonModal}
            onyes={onClickSave}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
          />
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleAddDialogClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />
          <SweetAlertModal
            headerText={"Do you want delete this?"}
            bodyText={"Are You sure?"}
            open={openLeosModal}
            onyes={handleLeosClose}
            close={() => {
              setopenLeosModal(false);
            }}
            id={2}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>

              {/* {dialogType === 'sub' && <DialogTitle>Sub Menu</DialogTitle>} */}
            </Grid>

            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>

          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "2rem" }}>
                    Restaurant
                  </Typography>
                </Grid>
                <Grid item xs={8} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Restaurant"}
                    datas={restaurantDatas}
                    value={restaurantAddedvalue}
                    val={restaurantAdded}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "2rem" }}>Name</Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    label="Name"
                    value={keyword}
                    onChange={handleKeyword}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ sx: { color: "#371B17" } }}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>Logo</Typography>
                </Grid>
                <Grid xs={9}>
                  <Button
                    variant="contained"
                    component="label"
                    //   color="primary"
                    className="uploadButton"
                  // style={{ backgroundColor: 'white', color: 'gray' }}
                  >
                    <img
                      src={galleryIcon}
                      alt="photo"
                    // style={{ width: '2rem' }}
                    />
                    Upload
                    <input
                      hidden
                      accept="image/*"
                      multiple
                      type="file"
                      onChange={handleImageUpload}
                      disabled={state.selectedImages.length >= 1}
                    />
                  </Button>
                </Grid>

                {/* image show start */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={9}>
                    <Grid container spacing={2}>
                      {state.selectedImages
                        ? state.selectedImages.map((image, index) => (
                          <Grid item xs={2} sm={2} md={2} key={index}>
                            {/* <Paper> */}
                            <div
                              style={{
                                position: "relative",
                                paddingTop: "20px",
                              }}
                            >
                              <img
                                src={image}
                                alt={`Preview ${index + 1}`}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <IconButton
                                style={{
                                  position: "absolute",
                                  top: "-6px",
                                  right: "-23px",
                                  color: "gray",
                                }}
                                onClick={() => handleDeleteImage(index)}
                              >
                                <CancelIcon />
                              </IconButton>
                            </div>
                            {/* </Paper> */}
                          </Grid>
                        ))
                        : ""}
                    </Grid>
                  </Grid>
                </Grid>
                {/* image show end */}
              </Grid>

              {/* <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem", marginTop: "0.2rem" }}>
                    Type Of Menu
                  </Typography>
                </Grid>
                <Grid item xs={8.2}>
                  {restaurantAdded.map((restaurant, index) => (
                    <Grid container key={restaurant.id} style={{ marginLeft: "1.5rem" }}>
                      <Grid item xs={3}>
                        <Typography style={{ paddingTop: "1rem", marginTop: "0.3rem" }}>
                          {restaurant.title}
                        </Typography>
                      </Grid>
                      <Grid item xs={8} style={{ paddingTop: "0.5rem", marginBottom: "0.2rem" }}>
                        <Autocomplete
                          multiple
                          id={`menu-select-${restaurant.id}`}
                          options={getMenuOptionsForRestaurant(restaurant)}
                          getOptionLabel={(option) => option.title} // Assuming `title` is the name of the menu type
                          value={menuType[restaurant.id] || []} // Current menu selection for this restaurant
                          onChange={(event, newValue) =>
                            handleMenuChange(restaurant.id, newValue) // Update menu selection
                          }
                          renderInput={(params) => (
                            <TextField {...params} label="Select Menu" variant="outlined" />
                          )}
                          isOptionEqualToValue={(option, value) => option.id === value.id} // Ensuring correct comparison
                          sx={{ width: "100%", paddingY: ".5rem" }}
                        />
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid> */}


              {/* <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Kitchen
                  </Typography>
                </Grid>
                <Grid item xs={8} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={88}
                    label={props.title}
                    placeholder={"Kitchen"}
                    datas={menuData}
                    value={addValue}
                    val={menuIds}
                  />

                </Grid>
              </Grid> */}

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography>Is Active?</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Switch
                    checked={switchCheck}
                    onChange={handleSwitchChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
              </Grid>

              {/* <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography>Select Scheduler</Typography>
                </Grid>
                <Grid item xs={8}>
                  <button
                    className="modalAddButton"
                    onClick={handleSelectScheduler}
                  >

                    Select Scheduler
                  </button>
                </Grid>
              </Grid> */}

              {/* <Grid container spacing={2} sx={{ padding: "0.5rem" }}>
                <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                  <Typography>Delivery:</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid container>
                    {restaurantAdded.map((restaurant, index) => {
                      const isDeliverySelected = menuType[restaurant.id]?.some(
                        (menutype) => menutype.title === "Delivery"
                      );
                      const isOnlyDeliverySelected =
                        menuType[restaurant.id]?.length === 1 &&
                        menuType[restaurant.id]?.some((menutype) => menutype.title === "Delivery");

                      const toggleState = checkedState.find(
                        (state) => state.resId === restaurant.id
                      );

                      const collectionToggleState = CollectionOnlycheckedState.find(
                        (state) => state.resId === restaurant.id
                      );

                      return (
                        <Grid
                          item
                          xs={6}
                          key={restaurant.id}
                          //sx={{ display: "flex", alignItems: "center" }}
                          sx={{ display: "flex", flexDirection: "column", gap: 0.5, alignItems: "left" }}
                        >
                          <Grid sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <Grid item xs={8} >
                              <Typography sx={{ marginRight: "0.5rem" }}>
                                {restaurant.title}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Switch
                                checked={toggleState?.checked || false}
                                onChange={() => handleCheckboxChange(index)}
                                inputProps={{ "aria-label": restaurant.title }}
                                size="small"
                                disabled={isOnlyDeliverySelected || !menuType[restaurant.id]?.some((menutype) => menutype.title === "Delivery")}
                              />
                            </Grid>
                          </Grid>
                          {toggleState?.checked && (
                            <div>
                              {restaurant.isDelivery && (
                                <Grid sx={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "2rem" }}>
                                  <Grid item xs={8}>
                                    <Typography sx={{ marginRight: "0.5rem" }}>
                                      Collection only
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <Tooltip
                                      title={
                                        restaurant?.isCollectionOnly
                                          ? "Restaurant is collection only."
                                          : "Restaurant is not collection only."
                                      }
                                      arrow
                                    >
                                      <span>
                                        <Switch
                                          checked={restaurant?.isCollectionOnly ? true : collectionToggleState?.checked || false}
                                          onChange={() => {
                                            if (!restaurant?.isCollectionOnly) {
                                              handleCollectionOnlyChange(restaurant.id);
                                            }
                                          }}
                                          size="small"
                                          disabled={restaurant?.isCollectionOnly}
                                        />
                                      </span>
                                    </Tooltip>

                                  </Grid>
                                </Grid>
                              )}
                            </div>
                          )}
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid> */}

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                  <div className="d-flex justify-content-end">
                    <Grid item xs={4}>
                      {props.editKeywordData ? (
                        <Button
                          className="AddItemButtons"
                          onClick={onClickUpdate}
                        >
                          Update
                        </Button>
                      ) : (
                        <Button
                          className="AddItemButtons"
                          onClick={() => setopenConfirmaitonModal(true)}
                        >
                          Save
                        </Button>
                      )}
                    </Grid>
                  </div>
                </Grid>
              </Grid>

              {/* <Grid item xs={1}></Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}></Grid>
                <Grid item xs={9}>
                  {dialogType === "sub" && (
                    <SectionTableSubSection
                      selectedValue={selectedData}
                      selectedSectionValue={selectedData}
                    />
                  )}
                </Grid>
              </Grid> */}

            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <CustomDialog
        open={openIconDilaog}
        dialogTitle={"Add Icon"}
        onClose={handleDialog}
      />
      <ArchiveDialog
        open={openArchiveDilaog}
        dialogType={IsactiveDialogType}
        onHandleAddItem={handleAddItem}
        onClose={handleDialog}
        onToggleSwitch={handleSwitchToggle}
      />

      {/* <CustomArchiveDialog
        onClose={handleDialog}
        headerText={"Achive Dialog"}
        bodyText={"This is Menu Archive"}
        open={openArchiveDilaog}
        onyes={deleteBin}
        id={2}
      /> */}
      <AddRestaurantDialog
        open={openRestaurantDialog}
        onHandleAddItem={handleAddItem}
        title={props.title}
      />
      {openMenuSchedulerSelectionDialog && (
        <MenuSchedulerSelectDialog
          open={openMenuSchedulerSelectionDialog}
          restaurantSelected={restaurantAdded}
          //onHandleAddItem={handleAddItem}
          onSave={(data) => setScheduleSelections(data)}
          prevScheduleSelecection={scheduleSelections}
          onClose={handleMenuSchedulerDialogClose}
        //onToggleSwitch={handleSwitchToggle}
        />
      )}

    </div>
  );
}

export default AddMenuDialog;
